import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Col, Glyphicon, Grid, Row } from "react-bootstrap";
import toastr from "toastr";
import moment from "moment";

import { getEntitlements, getEntitlement, updateEntitlement } from "./action";
import { VoucherOverviewActivityLogsPath } from "routes/paths";
import Loader from "../../Loader";
import { RemoteGrid } from "../../Grid/RemoteGrid";
import { Panel, PanelHeader } from "../../Panel";
import { Filters } from "../../Filter";
import { DetailsModal } from "./DetailsModal";
import {
  Order,
  VouchersOverviewListColumns,
  VoucherStatus,
  VouchersOverviewFilters,
} from "../../../constant";
import { DateRangeConfig } from "../../../components/Filter/config";

const initialEntitlement = {
  id: "",
  productNumber: "",
  isValid: "",
  status: "",
  lastStatusChanged: "",
  numberOfUnlock: "",
  numberOfUnlockLeft: "",
  validFrom: "",
  validTo: "",
  usageLimitType: "",
  usageLimit: "",
  requiresOnline: "",
  requiresLogin: "",
  registrations: [],
  family: "",
  packageName: "",
  voucherCode: "",
};

const isAdvanceDateFilter = true;
class VoucherOverview extends Component {
  constructor() {
    super();

    this.state = {
      isInitializing: false,

      // grid
      pagination: { currentPage: 1, pageSize: 10 },
      order: {
        sortBy: VouchersOverviewListColumns.last_activity,
        orderBy: Order.desc,
      },
      search: "",
      searchBy: 0,
      operation: 0,
      isGridLoading: false,

      // modal
      showDetailsModal: false,
      selectedEntitlement: initialEntitlement,

      // filter
      selectedFamily: { text: "", value: -1 },
      selectedPackageName: { text: "", value: -1 },
      ...DateRangeConfig.DEFAULT_DATERANGE,
    };

    this.searchGrid = this.searchGrid.bind(this);
    this.searchGrid = debounce(this.searchGrid, 500);
  }

  componentDidMount() {
    this.setState({ isInitializing: true });
    this.setState({ isInitializing: false });
  }

  handleTableChange = async (type, state) => {
    this.setState({
      isGridLoading: true,
      pagination: {
        currentPage: state.page,
        pageSize: state.sizePerPage,
      },
      order: {
        sortBy: VouchersOverviewListColumns[state.sortField],
        orderBy: Order[state.sortOrder],
      },
    });

    await this.props.getEntitlements(
      state.page,
      state.sizePerPage,
      VouchersOverviewListColumns[state.sortField],
      Order[state.sortOrder],
      this.state.selectedFamily.value,
      this.state.selectedPackageName.text,
      this.state.searchBy,
      this.state.search,
      this.state.operation,
      this.state.startDate,
      this.state.endDate
    );

    this.setState({ isGridLoading: false });
  };

  handleSearch = async (searchCriteria) => {
    this.setState({
      search: searchCriteria.searchText,
      searchBy: searchCriteria.searchBy,
      operation: searchCriteria.operation,
      pagination: {
        ...this.state.pagination,
        currentPage: 1,
      },
    });
    if (isAdvanceDateFilter && searchCriteria.searchText === "") {
      return;
    }
    await this.searchGrid();
  };

  searchGrid = async () => {
    this.setState({ isGridLoading: true });

    await this.props.getEntitlements(
      this.state.pagination.currentPage,
      this.state.pagination.pageSize,
      this.state.order.sortBy,
      this.state.order.orderBy,
      this.state.selectedFamily.value,
      this.state.selectedPackageName.text,
      this.state.searchBy,
      this.state.search,
      this.state.operation,
      this.state.startDate,
      this.state.endDate
    );

    this.setState({ isGridLoading: false });
  };

  handleUpdateEntitlement = async (entitlement) => {
    this.setState({ isGridLoading: true });

    const response = await this.props.getEntitlement(
      entitlement.entitlement_id
    );
    if (response.isSuccess) {
      this.setState(
        {
          selectedEntitlement: {
            id: response.payload.entitlement_id,
            productNumber: response.payload.product_number,
            isValid: response.payload.is_valid,
            status: response.payload.status,
            lastActivity: response.payload.last_activity
              ? moment(response.payload.last_activity).format("L")
              : "-",
            numberOfUnlock: response.payload.number_of_unlock,
            numberOfUnlockLeft: response.payload.number_of_unlock_left,
            validFrom: moment(response.payload.valid_from).format("L"),
            validTo: moment(response.payload.valid_to).format("L"),
            usageLimitType: response.payload.usage_limit_type,
            usageLimit: response.payload.usage_limit,
            requiresOnline: response.payload.requires_online,
            requiresLogin: response.payload.requires_login,
            requiresFWVers: response.payload.requires_fw_vers,
            purpose: response.payload.purpose,
            createdBy: response.payload.created_by,
            registrations: response.payload.registrations,

            family:
              entitlement.units.length > 0
                ? entitlement.units[0].family_name
                : null,
            packageName: entitlement.package_name,
            voucherCode: entitlement.voucher_code,
          },
        },
        () => this.toggleDetailsModal()
      );
    } else {
      toastr.error(response.payload.error, "Error");
    }

    this.setState({ isGridLoading: false });
  };

  handleSubmit = async (values, actions) => {
    const status =
      VoucherStatus[values.status] === VoucherStatus.Invalid ? true : false;
    const response = await this.props.updateEntitlement(values.id, status);

    if (response.isSuccess) {
      this.toggleDetailsModal();
      toastr.info(response.payload.message, "Update");
      this.setState({ isGridLoading: true });

      await this.props.getEntitlements(
        this.state.pagination.currentPage,
        this.state.pagination.pageSize,
        this.state.order.sortBy,
        this.state.order.orderBy,
        this.state.selectedFamily.value,
        this.state.selectedPackageName.text,
        this.state.searchBy,
        this.state.search,
        this.state.operation,
        this.state.startDate,
        this.state.endDate
      );

      this.setState({ isGridLoading: false });
    } else {
      toastr.error(response.payload.error, "Error");
    }

    actions.setSubmitting(false);
  };

  toggleDetailsModal = () => {
    this.setState({ showDetailsModal: !this.state.showDetailsModal });
  };

  handleFilterChange = async (state) => {
    await this.setState({
      selectedFamily: state.family,
      selectedPackageName: state.packageName,
      isGridLoading: true,
      pagination: {
        ...this.state.pagination,
        currentPage: 1,
      },
      startDate: state.dateRange.value.startDate,
      endDate: state.dateRange.value.endDate,
    });

    await this.props.getEntitlements(
      this.state.pagination.currentPage,
      this.state.pagination.pageSize,
      this.state.order.sortBy,
      this.state.order.orderBy,
      state.family.value,
      state.packageName.text,
      this.state.searchBy,
      this.state.search,
      this.state.operation,
      this.state.startDate,
      this.state.endDate
    );

    this.setState({ isGridLoading: false });
  };

  render() {
    const columns = [
      {
        dataField: "last_activity",
        text: "Last Activity",
        sort: true,
        formatter: (cell) => {
          return moment(cell).format("LLL");
        },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => moment(cell).format("LLL"),
      },
      {
        dataField: "entitlement_id",
        text: "Id",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "voucher_code",
        text: "Voucher Code",
        sort: true,
        searchFilter: { searchable: true, dataType: "string" },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "units[0].family_name",
        text: "Family",
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "package_name",
        text: "Package Name",
        sort: true,
        searchFilter: { searchable: true, dataType: "string" },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "purpose",
        text: "Purpose",
        sort: false,
        searchFilter: { searchable: true, dataType: "string" },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "status",
        text: "Status",
        sort: false,
        searchFilter: { searchable: true, dataType: "string" },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "created_by",
        text: "Created By",
        sort: true,
        searchFilter: { searchable: true, dataType: "string" },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "buttons",
        text: "",
        formatter: (cell, row) => (
          <div className="btn-toolbar">
            <Button
              bsStyle="primary"
              title="Edit Voucher"
              onClick={() => this.handleUpdateEntitlement(row)}
            >
              <Glyphicon glyph="pencil" />
            </Button>
          </div>
        ),
      },
    ];

    const defaultSortedBy = [
      {
        dataField: "last_activity",
        order: "desc",
      },
    ];

    if (this.state.isInitializing) {
      return <Loader fullpage message="Loading voucher overview" />;
    }

    return (
      <Grid fluid>
        <h1>Voucher Overview</h1>

        <Row>
          <Col md={10} mdPush={2}>
            <Panel>
              <PanelHeader>
                <Button
                  bsSize="small"
                  bsStyle="primary"
                  onClick={() =>
                    this.props.history.push(VoucherOverviewActivityLogsPath)
                  }
                >
                  <Glyphicon glyph="tasks" /> View Activity Logs
                </Button>
              </PanelHeader>
              <div className="panel-body">
                <RemoteGrid
                  filterFields={VouchersOverviewFilters}
                  data={this.props.entitlements}
                  columns={columns}
                  pagination={this.state.pagination}
                  loading={this.state.isGridLoading}
                  onTableChange={this.handleTableChange}
                  onSearch={this.handleSearch}
                  defaultSorted={defaultSortedBy}
                />
              </div>
            </Panel>
          </Col>
          <Filters
            hasDateRange
            isAdvanceDateFilter={isAdvanceDateFilter}
            hasSearched={this.state.search !== ""}
            className="col-md-2 col-md-pull-10"
            initialValues={{ packageName: { text: "", value: -1 } }}
            onFilterValueChange={this.handleFilterChange}
            dateRangeFilterTitle="Last Activity"
          />
        </Row>
        <DetailsModal
          show={this.state.showDetailsModal}
          initialValues={this.state.selectedEntitlement}
          onModalClose={this.toggleDetailsModal}
          onFormSubmit={this.handleSubmit}
        />
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    entitlements: state.voucherOverview.entitlements,
  };
}

const mapDispatchToProps = {
  getEntitlements,
  getEntitlement,
  updateEntitlement,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherOverview);

const debounce = (callback, wait) => {
  let timeout;
  return (...args) => {
    const next = () => callback(...args);
    clearTimeout(timeout);
    timeout = setTimeout(next, wait);
  };
};
